import { render, staticRenderFns } from "./ParagraphsWithIcon.vue?vue&type=template&id=cd07d09c&scoped=true"
import script from "./ParagraphsWithIcon.vue?vue&type=script&lang=ts"
export * from "./ParagraphsWithIcon.vue?vue&type=script&lang=ts"
import style0 from "./ParagraphsWithIcon.vue?vue&type=style&index=0&id=cd07d09c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd07d09c",
  null
  
)

export default component.exports